<template>
  <div class="all_box">
    <div class="header_bar" @click="configPop()">
      <header-grad-round :title="'绿春县人民医院血液透析中心'" :LogoPath="LogoPath" v-if="headerTheme === 'header_gradRound'" />
      <header-common :title="'绿春县人民医院血液透析中心'" :LogoPath="LogoPath" v-if="headerTheme === 'header_common'" />
      <header-grad :title="'绿春县人民医院血液透析中心'" :LogoPath="LogoPath" v-if="headerTheme === 'header_grad'" />
    </div>

    <div class="content">
      <content-table v-if="contentTheme === 'content_table' && is_plan" :patData="PatList" />
      <content-list v-if="contentTheme === 'content_list' && is_plan" :patData="PatList" />
      <content-block v-if="contentTheme === 'content_block' && is_plan" :patData="PatList" />
      <Education v-if="!is_plan" :videoList="videoList" />
    </div>

    <div class="footer">
      <footer-common :mtime="mtime" />
    </div>

    <div class="drawer_box" v-if="drawer" :style="{ width: drawer ? '70vw' : '0vw' }">
      <div style="width: 100%;height: 100%;overflow-y: scroll;" :style="{ display: drawer ? 'block' : 'none' }">
        <!-- <el-button type="primary" @click="toConfig">系统配置</el-button> -->
        <!-- <el-button type="danger" @click="Logout">退出登录</el-button> -->
        <div style="width: 100%;display: flex;align-items: center;justify-content: space-between;margin-top: 20px;">
          <div style="display: flex;align-items: center;justify-content: flex-start;">
            <button class="button" type="button" @click="toConfig"
              style="background-color: var(--color-primary);">系统配置</button>
            <button class="button" type="button" @click="Logout"
              style="background-color: var(--color-danger);">退出登录</button>
            <button class="button" type="button" @click="refresh"
              style="background-color: var(--color-primary);">刷新数据</button>
            <button class="button" type="button" @click="refreshWeb"
              style="background-color: var(--color-primary);">刷新网页</button>
          </div>
          <button class="button" type="button" @click="drawer = false"
            style="background-color: var(--color-warning);">关闭弹窗</button>
        </div>
        <Divider text="主题颜色" />
        <div class="theme_image_box">
          <div v-for="color in themeColor" :key="color"
            :style="{ backgroundColor: color, border: selectColor === color ? '2px solid #fff' : '' }"
            class="theme_color" @click="selectThemeColor(color)"></div>
        </div>
        <div v-for="(item, index) in themeImage" :key="index">
          <Divider :text="item.title" />
          <div class="theme_image_box">
            <img class="theme_image" v-for="(ls, index) in item.list" :key="index" :src="ls.src"
              :style="{ border: headerTheme === ls.flg || contentTheme === ls.flg || footerTheme === ls.flg ? '2px solid #1D84FF' : '' }"
              alt="" srcset="" @click="selectTheme(ls)">
          </div>
        </div>
      </div>
    </div>

    <div class="callOutPop" v-if="callOutPop">
      {{ callOutContent }}
    </div>
  </div>
</template>

<script>
// // 1. 导入所有组件和工具函数
import Divider from './modules/Divider/Divider.vue';
import { handleElementThemeColor } from '@/utils/ui/colors.js';

// // 导入图片资源
import logoImage from '../../assets/hospLogo.png';
import table from '../../assets/theme/table.png';
import list from '../../assets/theme/list.png';
import block from '../../assets/theme/block.png';
import headerGradRound from '../../assets/theme/header_grad_round.png';
import headerCommon from '../../assets/theme/header_common.png';
import headerGradI from '../../assets/theme/header_grad.png';

// // 导入业务组件
import ContentTable from './modules/content/table.vue';
import ContentList from './modules/content/list.vue';
// import ContentBlock from './modules/content/block.vue';
import HeaderGradRound from './modules/header/headerGradRound.vue';
import HeaderCommon from './modules/header/headerCommon.vue';
import headerGrad from './modules/header/headerGrad.vue';
import FooterCommon from './modules/footer/footerCommon.vue';
import Education from './modules/education/education.vue';

// 导入工具方法
// import { postMessageToApp } from '@/utils/environment/uniapp.js';
import { initSocket, closeSocket, SendClientBoardCast } from '../../utils/ws/SocketDUtil';
import { mapState } from 'vuex'
import { CallPubMsg, CallAdo, refreshInstance } from '@/utils/request'
import router from '../../router';

export default {
  name: 'Home', // Vue2推荐显式声明组件名
  // 2. 注册所有组件（Vue2必须显式注册）
  components: {
    Divider, // eslint-disable-line vue/no-unused-components
    ContentTable, // eslint-disable-line vue/no-unused-components
    ContentList, // eslint-disable-line vue/no-unused-components
    // ContentBlock,
    HeaderGradRound, // eslint-disable-line vue/no-unused-components
    HeaderCommon, // eslint-disable-line vue/no-unused-components
    headerGrad,  // eslint-disable-line vue/no-unused-components
    FooterCommon, // eslint-disable-line vue/no-unused-components
    Education // eslint-disable-line vue/no-unused-components
  },
  // 3. 响应式数据（替代Vue3的ref）
  data() {
    return {
      LogoPath: logoImage, // 图片路径
      drawer: false, // 抽屉弹窗控制
      // 主题图片配置
      themeImage: [
        {
          title: '头部',
          list: [
            { id: 1, src: headerGradRound, name: '渐变圆角', flg: 'header_gradRound' },
            { id: 2, src: headerCommon, name: '普通', flg: 'header_common' },
            { id: 3, src: headerGradI, name: '渐变头部', flg: 'header_grad' },
          ]
        },
        {
          title: '内容',
          list: [
            { id: 1, src: table, name: '表格布局', flg: 'content_table' },
            { id: 2, src: list, name: '列表布局', flg: 'content_list' },
            { id: 3, src: block, name: '块布局', flg: 'content_block' }
          ]
        },
        {
          title: '底部',
          list: [
            { id: 1, src: headerCommon, name: '普通', flg: 'footer_common' },
          ]
        }
      ],
      //   // 主题选择状态
      headerTheme: 'header_gradRound',
      contentTheme: 'content_table',
      footerTheme: 'footer_common',
      // 主题颜色
      themeColor: [
        '#5D87FF', '#B48DF3', '#1D84FF', '#60C041', '#38C0FC',
        '#F9901F', '#FF80C8', '#6222C9', '#E63415', '#409EFF',
        '#2E8889', '#8A795D', '#A82A70', '#0C3804', '#1A28B9'
      ],
      selectColor: '', // 选中的主题颜色
      // 呼叫弹窗
      callOutPop: false,
      callOutContent: '',
      callOutStore: null,
      stopCallOutWatch: null, // 监听停止函数
      PatList: [],
      mtime: new Date(), // 基准时间

      videoList: [], //宣教视频列表
      time_cfg: {}, //时间配置

      play_time: [], //播放时间记录
      is_plan: true, // 是否播放排班
      timer: null,
      curTime: new Date(),
    };
  },
  computed: {
    ...mapState({
      callOutMsg: state => state.auth.CALL_OUT_MSG
    })
  },
  // 4. 生命周期钩子（替代Vue3的onMounted/onUnmounted）
  created() {
    this.getData()
  },
  watch: {
    // 监听callOutMsg计算属性
    callOutMsg: {
      // 状态变化时执行的处理函数
      handler(newVal) {
        console.log(newVal);

        // 调用自定义方法处理变化
        this.handleCallOutMsgChange(newVal)
      },
      deep: true, // 关键：对象类型必须开启深度监听（检测内部属性变化）
      immediate: false // 可选：是否在组件初始化时立即执行一次（按需设置）
    }
  },
  mounted() {
    // 加这一句！
    refreshInstance()
    // 初始化Socket
    initSocket();
    this.$nextTick(() => {
      setTimeout(() => {
        this.getData()
      }, 500); // 500ms延迟，可根据设备调整
    });


    // 读取本地存储的主题配置
    const storedHeaderTheme = localStorage.getItem('headerTheme');
    const storedContentTheme = localStorage.getItem('contentTheme');
    const storedFooterTheme = localStorage.getItem('footerTheme');
    if (storedHeaderTheme) {
      this.headerTheme = JSON.parse(storedHeaderTheme);
    }
    if (storedContentTheme) {
      this.contentTheme = JSON.parse(storedContentTheme);
    }
    if (storedFooterTheme) {
      this.footerTheme = JSON.parse(storedFooterTheme);
    }

    // 读取主题颜色
    const storedThemeColor = localStorage.getItem('themeColor');
    if (storedThemeColor) {
      handleElementThemeColor(storedThemeColor);
      this.selectColor = storedThemeColor;
    }

    // 监听App消息（替代Vue3的nextTick）
    this.$nextTick(() => {
      window.getVueMessage = (data) => {
        console.log('收到来自App的消息：', JSON.stringify(data));
        if (data.type === 'pop') {
          this.callOutPop = false;
        }
      };
    });
  },
  beforeDestroy() {
    // 组件销毁前清理资源
    closeSocket(); // 关闭Socket
    if (this.stopCallOutWatch) {
      this.stopCallOutWatch(); // 停止监听
    }
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  // 5. 所有方法（替代Vue3的顶层函数）
  methods: {
    refresh() {
      this.getData()
    },
    refreshWeb() {
      if (this.$isAppEnvironment()) {
        // 发送关闭APP指令
        this.$postMessageToApp('instruct', 'app_refreshCache', '');
      }
    },
    updateTime() {
      let now;
      if (this.mtime) {
        // 有基准时间时：基于基准时间每秒+1秒（定时器1秒执行一次）
        this.mtime.setSeconds(this.mtime.getSeconds() + 1);
        now = new Date(this.mtime);
      } else {
        // 无基准时间时：使用当前系统时间
        now = new Date();
      }
      this.curTime = now;

      if (this.isInTimeRange() !== this.is_plan) {
        this.is_plan = this.isInTimeRange()
      }
    },
    async getData() {
      let pdata = {
        "req": "LOAD",
        "task_tm_plan": ""
      }
      const res = await CallAdo('evt00040', pdata);
      // console.log('获取数据结果：', JSON.stringify(res));

      if (res.sta !== 1) {
        // this.$myNotify({
        //   title: '警告',
        //   message: res.message || '获取失败！',
        //   type: 'error'
        // })
        return
      }

      if (!res.body.res) {
        // this.$myNotify({
        //   title: '警告',
        //   message: res.msg || '获取失败！',
        //   type: 'error'
        // })
        return
      }


      this.PatList = [...res.body.ds1]
      this.mtime = new Date(res.mtime)
      this.$nextTick(() => {
        setTimeout(() => {
          this.getConfigData()
        }, 500); // 500ms延迟，可根据设备调整
      });

    },

    // 计算属性：判断当前时间是否在任意时间段内 
    isInTimeRange() {
      const now = new Date(this.curTime);
      const nowTotalSeconds = this.getTimeTotalSeconds(now);


      const gzStartTotalSeconds = this.getTimeTotalSeconds(new Date(this.time_cfg.gzTime[0]));
      const gzEndTotalSeconds = this.getTimeTotalSeconds(new Date(this.time_cfg.gzTime[1]));

      // 2. 遍历所有时间范围，逐一判断
      for (const [startTimeStr, endTimeStr] of this.play_time) {

        // 将UTC时间字符串转为本地时间对象
        const startDate = new Date(startTimeStr);
        const endDate = new Date(endTimeStr);

        // 提取起始/结束时间的总秒数（仅时分秒）

        const startTotalSeconds = this.getTimeTotalSeconds(startDate);
        const endTotalSeconds = this.getTimeTotalSeconds(endDate);

        // 3. 判断当前时间是否在该时间段内 && (nowTotalSeconds >= gzStartTotalSeconds && nowTotalSeconds <= gzEndTotalSeconds)
        if (nowTotalSeconds >= startTotalSeconds && nowTotalSeconds <= endTotalSeconds && (nowTotalSeconds >= gzStartTotalSeconds && nowTotalSeconds <= gzEndTotalSeconds)) {
          return true;
        }
      }

      // 所有时间段都不满足
      return false;
    },
    getTimeTotalSeconds(date) {

      const hours = date.getHours(); // 本地小时（0-23）
      const minutes = date.getMinutes(); // 本地分钟（0-59）
      const seconds = date.getSeconds(); // 本地秒数（0-59）

      return hours * 3600 + minutes * 60 + seconds;
    },

    // 获取配置数据
    async getConfigData() {
      let pstData2 = {
        req: 'LOAD',
        cfg_key: 'screen_cfg'
      };
      const res = await CallAdo('evt00042', pstData2)
      if (res.sta !== 1) {
        this.$myNotify({
          title: '警告',
          message: res.message || '获取失败！',
          type: 'error'
        })
        return
      }

      if (!res.body.res) {
        this.$myNotify({
          title: '警告',
          message: res.msg || '获取失败！',
          type: 'error'
        })
        return
      }


      if (res.body.ds1.length > 0) {
        this.videoList = [...res.body.ds1[0].cfg_val.videoList]
        this.time_cfg = { ...res.body.ds1[0].cfg_val.time_cfg }
        console.log(this.time_cfg);

        this.play_time = [this.time_cfg.wabTime, this.time_cfg.yebTime, this.time_cfg.zabTime, this.time_cfg.zhbTime]

        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        // console.log('配置数据：', JSON.stringify(this.play_time));
        this.timer = setInterval(this.updateTime, 1000);
      }
    },


    // 打开配置弹窗
    configPop() {
      this.drawer = true;
    },
    // 选择主题
    selectTheme(item) {
      console.log('选择主题', item);
      const type = item.flg.split('_')[0]; // header/content/footer
      if (type === 'header') {
        this.headerTheme = item.flg;
      } else if (type === 'content') {
        this.contentTheme = item.flg;
      } else if (type === 'footer') {
        this.footerTheme = item.flg;
      }
      // 存储到本地
      const key = `${type}Theme`;
      localStorage.setItem(key, JSON.stringify(item.flg));
    },
    // 跳转系统配置
    toConfig() {
      console.log('跳转系统配置');
      // postMessageToApp('instruct', 'app_toConfig', '');
      if (this.$isAppEnvironment()) {
        // 发送关闭APP指令
        this.$postMessageToApp('instruct', 'app_toConfig', '');
      } else {
        alert('当前非APP环境');
      }
    },
    // 退出登录
    Logout() {
      console.log('退出登录');
      // closeSocket();
      // this.usrstore.SetTokenExpires();
      this.$store.commit('auth/SET_TOKEN_EXPIRES');
      // this.$store.router = 'login'; 
      router.push('/');
    },
    // 选择主题颜色
    selectThemeColor(color) {
      console.log('选择主题颜色', color);
      handleElementThemeColor(color);
      this.selectColor = color;
      // 存储到本地
      localStorage.setItem('themeColor', color);
    },
    // 处理消息变化
    handleCallOutMsgChange(val) {
      console.log('CALL_OUT_MSG 对象变化=======：', JSON.stringify(val));
      console.log('消息类型：', val.type);

      // 叫号消息
      if (val.type === "clientbroadcast") {
        // console.log('消息类型非clientbroadcast，忽略处理');
        // return;
        this.callOutContent = val.content;
        this.callOutPop = true;
        // postMessageToApp('message', 'callOut', this.callOutContent);
        if (this.$isAppEnvironment()) {
          // 发送关闭APP指令
          this.$postMessageToApp('message', 'callOut', this.callOutContent);
        } else {
          alert('当前非APP环境');
        }
      }

      // 数据更新事件，重新获取数据
      if(val.type === "evt.tsk.upd"){
        let screen = JSON.parse(val.content).screen
        if(screen === 1){
          this.getData()
        }
      }
    }
  }
};
</script>

<style scoped>
.all_box {
  width: 100%;
  height: 100vh;
  padding: 0.15rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
}

.callOutPop {
  width: 60%;
  height: 50%;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  background-color: var(--color-primary-dark-2);
  /* 替换--el-color-primary-dark-2 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  color: #fff;
}

.header_bar {
  width: 100%;
  height: 0.8rem;
  background-color: var(--color-primary-light-5);
  /* 替换--el-color-primary-light-5 */
  border-radius: 0.1rem;
  font-size: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.content {
  height: calc(100% - 1.6rem);
  display: flex;
  justify-content: center;
  padding: 0.1rem 0;
}

.footer {
  width: 100%;
  height: 0.8rem;
}

.button {
  font-size: 0.3rem;
  height: 0.7rem;
  /* line-height: 0.7rem; */
  margin: 0 0.1rem;
  padding: 0 0.2rem;
  color: #fff;
  border: none;
  border-radius: 0.1rem;
  cursor: pointer;
}

.button:active {
  opacity: 0.8;
}

.drawer_box {
  height: 100vh;
  transition: 500ms;
  position: fixed;
  right: 0;
  background: rgba(240, 239, 239, 0.95) !important;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2) !important;
}

.theme_image_box {
  display: flex;
  flex-wrap: wrap;
  gap: 0.2rem;
  padding: 0.3rem 0.1rem;
}

.theme_color {
  width: 1rem;
  height: 1rem;
  border-radius: 0.1rem;
  cursor: pointer;
  box-sizing: border-box;
  margin-right: 0.1rem;
  margin-top: 0.1rem;
  transition: 300ms;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.theme_image {
  width: 2.5rem;
  height: 1.5rem;
  border-radius: 0.1rem;
  margin-right: 0.1rem;
  margin-top: 0.1rem;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
</style>